import api from './api';
import type {
  AdminClientsResponse,
  AdminExpertsResponse,
  AdminExpertDetail,
  AdminUsersResponse,
  GetAdminClientsParams,
  GetAdminUsersParams,
} from './admin-users.service';
import type { ApiResponse } from '@/utils/api-response.util';
import type { ClientDetails } from '@/types/client';

// Панель продакт-менеджера (/pm/users/...). Окремі маршрути бекенду `pm/*`, щоб сторінки продакта розвивались
// незалежно від адмінських; форма даних поки та сама, що й в адмінці.

export type PmClientsParams = Omit<GetAdminClientsParams, 'planCode'>;
export type PmUsersParams = GetAdminUsersParams;

const emptyList = (limit?: number) => ({ data: [], meta: { total: 0, page: 1, limit: limit ?? 25 } });

class PmUsersService {
  async getClients(params: PmClientsParams): Promise<AdminClientsResponse> {
    const { data: body } = await api.get<any>('/pm/clients', { params });
    return body?.success && Array.isArray(body.data) ? { data: body.data, meta: body.meta } : emptyList(params.limit);
  }

  async getExperts(params: PmClientsParams): Promise<AdminExpertsResponse> {
    const { data: body } = await api.get<any>('/pm/experts', { params });
    return body?.success && Array.isArray(body.data) ? { data: body.data, meta: body.meta } : emptyList(params.limit);
  }

  async getUsers(params: PmUsersParams): Promise<AdminUsersResponse> {
    const { data: body } = await api.get<any>('/pm/users', { params });
    return body?.success && Array.isArray(body.data) ? { data: body.data, meta: body.meta } : emptyList(params.limit);
  }

  // Картка клієнта (/pm/client/:id). Поки той самий профіль, що бачить експерт; обсяг даних для продакта ще визначаємо.
  async getClient(id: number): Promise<ClientDetails> {
    const response = await api.get<ApiResponse<ClientDetails>>(`/pm/clients/${id}`);
    return response.data.data;
  }

  // Картка експерта (/pm/expert/:id). Поки ті самі дані, що в картці експерта в адмінці.
  async getExpert(id: number): Promise<AdminExpertDetail> {
    const response = await api.get<ApiResponse<AdminExpertDetail>>(`/pm/experts/${id}`);
    return response.data.data;
  }
}

export const pmUsersService = new PmUsersService();
